/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMediaQuery } from "@mui/material";
import { poisBountyAssets } from "assets/cdn";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import { useEffect, useState } from "react";
import { useSelectPoisEventMutation } from "redux/apis/poisBounty";
import {
	onClosePopUp,
	onPBV3change,
	selectPoisBountyV3State
} from "redux/slices";
import {
	Button,
	Container,
	Description,
	Title,
	WarningMessage
} from "./styles";

interface PBV3SelectEventProps {}

export const PBV3SelectEvent = ({}: PBV3SelectEventProps) => {
	const isPortrait = useMediaQuery(
		"(orientation: portrait) and (max-width: 899px)"
	);
	const scale = useCalculateScale(
		isPortrait ? 400 : 1050,
		isPortrait ? 600 : 400
	);
	const dispatch = useAppDispatch();
	const { getImage } = useImagePath("cdn");
	const [loading, setLoading] = useState(false);
	//const [pbDisplayed] = usePbDisplayedMutation();
	const [selectPoisEvent] = useSelectPoisEventMutation();
	const { data } = useAppSelector(selectPoisBountyV3State);
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();

	// Función helper para obtener un tracker por eventType
	const getEventByType = (eventType: string) =>
		Object.values(data?.trackersData || {}).find(
			(tracker) => tracker.eventType === eventType
		);

	const onSelectEvent = async (eventType: string) => {
		setLoading(true);
		dispatch(onPBV3change({ allRewardsCollected: false }));
		const filterPrimaryEvent = getEventByType(eventType);
		const filterSecondaryEvent = getEventByType(
			eventType === "user" ? "club" : "user"
		);
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "event_type_chosen",
			event_type: "pois_bounty_v3",
			action: "pb_type_chosen",
			source: "pois_bounty_v3",
			type:
				filterPrimaryEvent?.eventType === "user"
					? "personal"
					: filterPrimaryEvent?.eventType,
			event_id: filterPrimaryEvent?.eventId
		});
		await selectPoisEvent({
			eventId: filterPrimaryEvent?.eventId || "",
			otherEventId: filterSecondaryEvent?.eventId || ""
		}).unwrap();
		//await pbDisplayed({ eventId: filterPrimaryEvent?.eventId || "" }).unwrap();

		setLoading(false);
		onClose();
	};

	const onClose = async () => {
		dispatch(onClosePopUp());
	};

	useEffect(() => {
		if (Object.values(data?.trackersData || {})) {
			const eventIds = Object.values(data?.trackersData || {}).map(
				(trackers) => trackers.eventId
			);
			// extract all unique eventType to send as json
			const eventTypes = Object.values(data?.trackersData || {}).map(
				(tracker) => tracker.eventType
			);
			const uniqueEventTypes = Array.from(new Set(eventTypes));
			const pbOptions = uniqueEventTypes.map((type) =>
				type === "user" ? "personal" : type
			);

			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "event_type_shown",
				event_type: "pois_bounty_v3",
				action: "pb_type_shown",
				source: "pois_bounty_v3",
				type: JSON.stringify(pbOptions),
				event_id: JSON.stringify(eventIds)
			});
		}
	}, [Object.values(data?.trackersData || {})?.length]);

	return (
		<Container
			scale={scale}
			image={getImage(
				isPortrait
					? poisBountyAssets.v3.cycle.background
					: poisBountyAssets.v3.cycle.backgroundLandscape
			)}
		>
			<div>
				<Title>A Club Poi’s Bounty is available!</Title>
				<Description>
					{isPortrait ? (
						<>
							You can continue your Personal event or switch to the Club event.
						</>
					) : (
						<>
							You can continue your Personal event or switch to
							<br /> the Club event.
						</>
					)}
				</Description>
			</div>
			<div>
				{isPortrait && (
					<WarningMessage>
						You can switch once, and your choice will be locked for this event.
					</WarningMessage>
				)}
				<div>
					<Button
						themeColor="secondary"
						onClick={() => onSelectEvent("user")}
						disabled={loading}
					>
						Stay on Personal Event
					</Button>
					<Button
						themeColor="secondary"
						onClick={() => onSelectEvent("club")}
						disabled={loading}
					>
						Switch to Club Event
					</Button>
				</div>
				{!isPortrait && (
					<WarningMessage color="#000">
						You can switch once, and your choice will be locked for this event.
					</WarningMessage>
				)}
			</div>
		</Container>
	);
};
